<template>
  <div
    class="opple-config-platform"
  >
    <TopBar
      ref="Platform"
      :device="device"
      :is-delete-loading="isDeleteLoading"
      :has-data="deviceCard !== null || areaCard !== null"
      @showDeviceDialog="showDeviceDialog"
      @deleteIfttt="onDeleteIfttt" 
    />
    <div
      class="opple-config-platform_list"
    >
      <i
        v-if="isAddLoading"
        class="el-icon-loading"
      />
      <div
        v-if="!isAddLoading && deviceCard === null && areaCard === null"
        class="opple-config-platform_list-noData"
      >
        <img :src="noData">
        <p>{{ $t('ifttt.noConfiguration') }}</p>
      </div>
      <template v-if="!isAddLoading && deviceCard !== null">
        <OppleDeviceCard 
          :data="deviceCard"
          :select-type="selectType"
          @select="onSelect"
        />
      </template>
      <template v-if="!isAddLoading && areaCard !== null">
        <div class="opple-config-platform_areaCard">
          <span>{{ $t('otatask.areaname') }}:</span> {{ areaCard.AreaName }} {{ areaCard.IFT_ID }}
        </div>
      </template>
    </div>
    <OppleAreaDeviceDialog 
      v-if="parentGpNo"
      :title="$t('ifttt.selectObjects')"
      :visible="isAreaDeviceDialogVisible"
      :required-message-type="requiredMessageType.join(',')"
      :gp-no="parentGpNo"
      @onClose="handlerClose"
      @onOk="onDialogOk"
    />
    <Awake 
      :visible="isAwakeVisible"
      :device="device"
      :Gpno="gpNo"
      :is-loading-configuration="isLoadingConfiguration"
      @onOk="onAwakeOk"
      @onClose="onAwakeClose"
    />
  </div>
</template>
 
<script>
import OppleDeviceCard from '@/components/OppleDeviceCard/index.vue';
// import OpDeviceChoose from '@/components/common/OpDeviceChoose.vue';
import TopBar from './TopBar.vue';
import noData from '@/assets/img/no-data.png';
import { GetAutoTemplateById } from '@/axios/IDevice.js';
import { clearDeviceTriggerDetailCache, fetchTriggerAbility, getTriggerList } from '@/utils/triggerAbility';
import { fetchIFtttListByTrigger, getIFtttList } from '@/utils/iftttListByTrigger';
import { AddDeviceRelation, RemoveDeviceRelation } from "@/axios/IMonitor.js";
import { Create, BatchCreate, BatchDeletev1, Delete } from '@/axios/IFttt.js';
import {
  FindDevice
} from "@/axios/IDevice.js";
import OppleAreaDeviceDialog from '@/components/OppleTriggerIfttt/components/OppleAreaDeviceDialog';
import { getElfDefaultIfttt } from '../utils';
import Awake from './Awake.vue';
import { alerterror } from '@/assets/js/common.js';
export default {
  name: 'OppleConfigPlatform',
  components: {
    OppleDeviceCard,
    OppleAreaDeviceDialog,
    TopBar,
    Awake
  },
  props: {
    selectType: {
      type: Number,
      default: 0 // 0 则不出现设备选择框
    },
    device: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isAreaDeviceDialogVisible: false,
      checkeddata: [],
      gpNo: -1,
      currentTab: 0,
      isAddLoading: false,
      isDeleteLoading: false,
      deviceCard: null,
      areaCard: null,
      triggerList: [],
      isAwakeVisible: false,
      isLoadingConfiguration: false,
      areaDeviceData: null,
      requiredMessageType: [],
      parentGpNo: null,
      noData
    };
  },

  computed: {},

  watch: {
    device() {
      this.init();
      // this.setCom();
    }
  },

  mounted() {
    this.init();
  },

  methods: {
    async init() {
      debugger
      if (!this.device.VDeviceId) return;
      const device = this.device;
      const deviceGpNos = (device.ParentGpnos || '').replace(/\@/g, '').split(',') || [];
      const parentGpNo = Number(deviceGpNos[1]);

      this.parentGpNo = parentGpNo;
      // const ParentAreaNames = (this.device.ParentAreaNames || '').split(',') || [];
      // let gpNo = data.selectArea.id;
      // let areaName = data.selectArea.label;
      // let batchedGpNo = null;

      // if (deviceGpNos.length === data.selectArea.Level && data.selectArea.id !== this.device.Gpno) {
      //   const i = data.selectArea.Level - 1;
      //   batchedGpNo = Number(deviceGpNos[deviceGpNos.length - i]);
      //   // areaName = ParentAreaNames[i - 1];
      // }




      try {
        const res = await fetchTriggerAbility(this.device.VDeviceId);

      const triggerListRes = getTriggerList(res);
      const triggerGroupList = {
        SINGLES: []
      };

      const triggerControlList = [];

      triggerListRes.forEach(item => {
        const TriggerGroupName = item.UI?.TriggerGroup;

        if (TriggerGroupName) {
          if (item.UI?.AllowUsersEditAction !== 1) {
            if (triggerGroupList[TriggerGroupName]) {
              triggerGroupList[TriggerGroupName].push(item);
            } else {
              triggerGroupList[TriggerGroupName] = [item];
            }

            if (TriggerGroupName === 'UIControl_IftttManagement_Panel') {
              triggerControlList.push(item)
            }
          }
        }
      });

      const templateIDs = [];

      triggerControlList.forEach(item => {
        if (Array.isArray(item.UI?.commercialdefaultRecommendation)) {
          item.UI?.commercialdefaultRecommendation.forEach(recommend => {
            console.log('recommend.require', recommend.require);
            
            if (recommend.require !== false) {
              templateIDs.push(recommend.templateID)
            }
          })
        }
      });

      const needMsgType = new Set();

      const templatesRes = await GetAutoTemplateById({
        id: templateIDs.join(',')
      });

      const needDeviceActionList = (templatesRes.Result || []).reduce(
        (pre, next) => pre.concat(next.DeviceActionList), []);

      console.log('vvvv 0', templatesRes);

      needDeviceActionList.forEach(item => {
        if (item.Content?.MsgType) {
          needMsgType.add(item.Content?.MsgType)
        }
      })

      this.requiredMessageType = [...needMsgType]

      console.log('requiredMessageType', this.requiredMessageType);

      const triggerList = [];
      const showTriggers = Object.values(triggerGroupList).reduce((pre, next) => next.concat(pre), [])

      showTriggers.forEach(trigger => {        
        (trigger.OperationType || []).forEach(operation => {
          console.log('trigger', trigger);

          triggerList.push({
            ...trigger,
            OperationName: operation.Name,
            OperationValue: operation.Value,
            EnumValue: (trigger.EnumValue || []).map(item => ({
              ...item,
              iftttList: []
            }))
          })
        })
      });

        this.triggerList = triggerList;

        this.handlerIFttt(triggerList);
      } catch (e) {

      }
    },

    async handlerIFttt() {
      const iftttRes = await fetchIFtttListByTrigger(this.device.VDeviceId, { ShowEntry: 1 });

      let bindIfttt = null;
      let bindDevice = null;
      
      getIFtttList(iftttRes).forEach(ifttt => {
        (ifttt.TriggerList || []).forEach(triggerItem => {
          (triggerItem.TriggerList || []).forEach(trigger => {
            const triggerIfttt = this.triggerList.find(
              item => item.KeyID === trigger.KeyId &&
              item.ExtraKeyId === trigger.ExtraKeyId &&
              item.OperationValue === trigger.OperationType &&
              item.MsgID === trigger.MsgId
            );
            console.log('triggerIfttt', triggerIfttt);
            
            if (triggerIfttt) {
              // (triggerIfttt.EnumValue || []).forEach(enumItem => {
              //   if (Number(enumItem.Value) === Number(trigger.Value1)) {
                  if (!Array.isArray(triggerIfttt.iftttList)) {
                    triggerIfttt.iftttList = [];
                  }

                  if (!bindIfttt) {
                    const ExecuteTaskList = ifttt.ExecuteTaskList || [];
                    const ExecuteTask = ExecuteTaskList.filter(item => [0, 6].includes(item.ActionType))[0];
                    
                    if (ExecuteTask) {
                      if (ExecuteTask.ActionType === 6) {
                        this.areaCard = {
                          type: ExecuteTask.ActionType,
                          AreaName: ExecuteTask.AreaName,
                          Gpno: ExecuteTask.Gpno
                        };
                      }
                      if (ExecuteTask.ActionType === 0) {
                        if (!bindDevice) {
                          bindDevice = {
                            vDeviceId: ExecuteTask.VDeviceId,
                            channelId: ExecuteTask.ChannelId
                          }
                        }
                        // this.deviceCard = {
                        //   type: ExecuteTask.ActionType,
                        //   // AreaName: ExecuteTask.AreaName,
                        //   // Gpno: ExecuteTask.Gpno
                        // };
                      }
                    }
                  }

                  triggerIfttt.iftttList.push(ifttt);
              //   }
              // })
            }
          });
        });
      });

      if (bindDevice) {
        const deviceRes = await FindDevice(bindDevice);

        this.deviceCard = deviceRes.Result;
      }
    },  
    
    onItemClick(tab) {
      this.currentTab = tab;
    },
  

    // selectAll() {
    //   this.deviceCardList = this.deviceCardList.map((item) => ({ ...item, checked: true }))
    // },
  
    onSelect(data, isCheck) {
      // if (this.selectType === 1) {
      //   this.deviceCardList = this.deviceCardList.map((item) => {
      //     if (
      //       item.ClassSku === data.ClassSku &&
      //       item.VDeviceId === data.VDeviceId
      //     ) {
      //       return {
      //         ...item,
      //         checked: isCheck
      //       }
      //     }

      //     return {
      //       ...item,
      //     }
      //   })
      // }
      // console.log('data', data, isCheck, this.deviceCardList);
    },
    showDeviceDialog() {
      this.isAreaDeviceDialogVisible = true;
    },
    handlerClose() {
      this.isAreaDeviceDialogVisible = false;
    },

    async onAwakeOk() {
      debugger
      this.isLoadingConfiguration = true;
      const data = this.areaDeviceData;

      let iftttReqList = null;
      if (data.type === 'area') {
        // const area = data.selectArea;
        const deviceGpNos = (this.device.ParentGpnos || '').replace(/\@/g, '').split(',') || [];
        const ParentAreaNames = (this.device.ParentAreaNames || '').split(',') || [];
        let gpNo = data.selectArea.id;
        let areaName = data.selectArea.label;
        let batchedGpNo = null;

        // 不是选的自己
        if (data.selectArea.id !== this.device.Gpno) {
          if (deviceGpNos.length === data.selectArea.Level) {
            const i = data.selectArea.Level - 1;
            batchedGpNo = Number(deviceGpNos[deviceGpNos.length - i]);
          }
        };

        // if (
        //   deviceGpNos.length === data.selectArea.Level && 
        //   data.selectArea.id !== this.device.Gpno
        // ) {
        //   const i = data.selectArea.Level - 1;
        //   batchedGpNo = Number(deviceGpNos[deviceGpNos.length - i]);
        //   // areaName = ParentAreaNames[i - 1];
        // }

        iftttReqList = await getElfDefaultIfttt(this.device, {
          ActionType: 6,
          gpNo,
          areaName,
          batchedGpNo
        }, this.triggerList);
      }

      console.log('data.selectDevice', data.selectDevice);

      if (data.type === 'device') {
        iftttReqList = await getElfDefaultIfttt(this.device, {
          ActionType: 0,
          device: data.selectDevice
        }, this.triggerList);
      }

      try {
        const res = await BatchCreate(iftttReqList);
        
        if (res && res.StatusCode === 0 && Array.isArray(res.Result)) {
          const failData = res.Result.find(item => item.StatusCode !== 0);

          if (failData && failData.StatusCode && failData.StatusCode !== 0) {
            alerterror(this, failData.StatusCode);
          }else{
            this.$message({
            type: 'warning',
            message: failData.Message
          })
          }
        }
        this.isAwakeVisible = false;
      } catch (e) {
        console.log('e', e);
      } finally {
        this.isLoadingConfiguration = false;
        clearDeviceTriggerDetailCache(this.device.VDeviceId);
        this.init();
      }
    },

    onAwakeClose() {
      this.isAwakeVisible = false;
    },

    async onDialogOk(data) {
      this.areaDeviceData = data;
      this.handlerClose();
      this.isAwakeVisible = true;
      // console.log('data h', data);
      // const iftttCommonInfo = {
      //   Gpno: this.device.Gpno,
      //   TRI_Relation: 0,
      //   IsManual: false,
      //   IsEnable: true,
      //   TriggerType: 0,
      //   TimePeriod: {
      //     effectivedate: "2019-01-01,2088-12-31",
      //     holiday: false,
      //     time: "00:00",
      //     weeks: "Mon Tues Wed Thur Fri Sat Sun",
      //     zone: 0,
      //   },
      //   ShowEntry: 1
      // };

      // const triggerCommonInfo = {
      //   VDeviceId: this.device.VDeviceId,
      //   DeviceName: this.device.DeviceName,
      //   AreaName: this.device.AreaName,
      //   IsDel: false,
      //   ClassSku: this.device.ClassSku,
      // };

      // this.triggerList.forEach((trigger, index) => {
      //   let ActionType = 0;
      //   let ExecuteTaskList = null;

      //   if (data.type === 'area') {
      //     ExecuteTaskList = {
      //       ActionType: 6,
      //       Gpno: data.selectArea.id,
      //       AreaName: data.selectArea.label,
      //       Values: data.actions
      //     };
      //   } 

      //   if (data.type === 'device') {
      //     ExecuteTaskList = {
      //       ActionType: 0,
      //       Gpno: this.device.Gpno,
      //       AreaName: this.device.AreaName,
      //       Values: curAreaList.map((action) => ({
      //         ControlType: action.Content.ControlType,
      //         Value: action.Content.Value
      //       }))
      //     };
      //   }

      //   // let ifttt = {
      //   //   ...iftttCommonInfo,
      //   //   TriggerList: [{
      //   //     ...triggerCommonInfo,
      //   //     TriggerList: [{
      //   //       ExtraKeyId: trigger.ExtraKeyId,
      //   //       KeyId: trigger.KeyID,
      //   //       MsgId: trigger.MsgID,
      //   //       OperationType: Number(recommend.OperationValue),
      //   //       Value1: Number.isInteger(Number(recommend.Value1)) ? recommend.Value1 : Number(recommend.DefaultValue),
      //   //       Value2: Number.isInteger(Number(recommend.Value2)) ? recommend.Value2 : null,
      //   //     }]
      //   //   }],
      //   //   ExecuteTaskList: [ExecuteTaskList],
      //   //   UITemplateId: recommend.templateID,
      //   //   UITemplateVersion: recommend.version,
      //   //   IFtttName: recommend.name,
      //   // };


      //   // let ExecuteTaskList = {};
      //   // let needAdd = true;
      //   // console.log('trigger 1', trigger);

      //   // const defaultRecommendation = trigger.UI?.defaultRecommendation || [];
      //   // const defaultRecommendationIds = defaultRecommendation.map(
      //   //   recommendation => recommendation.templateID
      //   // );
      //   // console.log('trigger 2', defaultRecommendation);

      //   // defaultRecommendation.forEach(recommend => {
      //   //   const curTemplates = templates.filter(template => defaultRecommendationIds.includes(template.Id));
      //   //   const curAreaList = curTemplates.reduce((pre, next) => {
      //   //     return pre.concat(next.AreaActionList || []);
      //   //   }, []);
      //   //   console.log('trigger 3', recommend);
      //   //   // 地区
          

      //   //   recomends.push(ifttt);
      //   // });
      // });

      this.handlerClose();
    },

    async deviceValueChange(devlices) {
      const relativeDevices = devlices.map(device => ({
        ChildCategoryType: device.ChildCategoryType,
        DeviceId: this.device.DeviceId,
        UserFavoritesType: 1,
        RelationId: device.DeviceId,
      }));

      try {
        this.isAddLoading = true;

        this.handlerClose();

        const res = await AddDeviceRelation(relativeDevices);

        await this.requestRelationDeviceList();

        this.isAddLoading = false;
      } catch (e) {
        this.isAddLoading = false;
      }
      // console.log('devlices', relativeDevices);
    },

    async onDeleteIfttt() {
      this.isDeleteLoading = true;
      const iftttNos = [];

      this.triggerList.forEach(item => {
        if (item.iftttList) {
          item.iftttList.forEach(ifttt => {
            iftttNos.push(ifttt.IFT_ID)
          });
        }
      });

      Promise.all(iftttNos.map(no => Delete({
        iftttNo: no
      }))).then(res => {
        this.deviceCard = null;
        this.areaCard = null;
        clearDeviceTriggerDetailCache(this.device.VDeviceId);
        this.init();
        this.isDeleteLoading = false;
      });
    },
  },
};
</script>

<style lang="scss">
.opple-config-platform {
  flex: 1;

  &_list {
    display: flex;
    flex-wrap: wrap;
    padding-left: 10px;

    &-noData {
      margin: 0 auto;
      width: 280px;
      text-align: center;
      font-size: 12px;
      font-weight: 400;
      color: #9E9E9E;
  
      img {
        width: 100%;
        margin-bottom: 10px;
      }
    }

    .el-icon-loading {
      margin: 10px 100px;
    }
  }

  &_areaCard {
    min-width: 180px;
    padding: 10px 15px;
    border: 1px solid #DDDFE5;
    border-radius: 2px;

    span {
      color: #9E9E9E;
    }
  }

  .opple-device-card {
    margin: 10px;
  }
}

</style>

